<script setup lang="ts">
import { reactive } from 'vue';

import { fade, slideRight } from '@/helpers/motion';

import AuthEmail from '@/components/AuthEmail.vue';
import AuthOtp from '@/components/AuthOtp.vue';
import AuthWelcome from '@/components/AuthWelcome.vue';
import AuthLayout from '@/components/layouts/AuthLayout.vue';

enum AuthViewStep {
  Welcome = 'welcome',
  Email = 'email',
  Otp = 'otp'
}

const state = reactive<{
  step: AuthViewStep;
  email: string;
}>({
  step: AuthViewStep.Welcome,
  email: ''
});

function continueToEmail(): void {
  state.step = AuthViewStep.Email;
}

async function continueToOTP(email: string): Promise<void> {
  state.email = email;
  state.step = AuthViewStep.Otp;
}
</script>

<template>
  <AuthLayout class="auth-view">
    <AuthWelcome
      v-if="state.step === AuthViewStep.Welcome"
      v-motion="fade"
      @next="continueToEmail"
    />
    <AuthEmail
      v-if="state.step === AuthViewStep.Email"
      v-motion="slideRight"
      @next="continueToOTP"
    />
    <AuthOtp v-if="state.step === AuthViewStep.Otp" v-motion="slideRight" :email="state.email" />
  </AuthLayout>
</template>
